/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';

const BaseView = require('components-framework/view/base.view');
const trackingUtils = require('od-modules/utils/tracking.utils');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const {revampTrackingLabel} = require('od-modules/utils/membership_tracking.utils').default;
const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');
const openClass = Odigeo.Utils.isMobile() ? 'opened' : 'open';
const UNLOCKED_ACTION = 'unlocked';
const PRICE_RANGE = ['one', 'two', 'three', 'four', 'five'];
const STEPS = ['one', 'two', 'three'];
const PERKS = ['one', 'three', 'four', 'five'];
const PERKS_FLEX = ['one', 'two', 'three', 'four', 'five'];

const isMembershipFlexibility = () => Odigeo.Membership.isMembershipFlexibilityM || Odigeo.Membership.isMembershipFlexibilityD;

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    events: {
        'tap .want_be_member_lightbox': 'onMembershipPerksInfoLightboxButton',
        'tap .lightbox_perks_close': 'onCloseMembershipPerksInfoLightbox',
        'tap .perks_info_lightbox_container': 'onCloseMembershipPerksInfoLightboxTappingOutside',
        'tap .lightbox_terms_and_conditions': 'onClickTermsAndConditions',
    },
    selectors: {
        membershipPerksInfoLightboxContainer: '.perks_info_lightbox_container',
        lightboxImageContainer: '.od-lightbox-image',
    },
    initialize() {
        const isPriceWithoutDiscountSelected = Odigeo.Membership.isPriceWithoutDiscountSelected;
        this.model.set('isPrimePriceSelected', isPriceWithoutDiscountSelected !== 'true');
        this.model.set('state', isPriceWithoutDiscountSelected ? 'no-prime' : 'prime');
        return this;
    },
    getPerks() {
        let perks = PERKS;
        if (isMembershipFlexibility()) {
            perks = PERKS_FLEX;
        }
        return perks;
    },
    async renderPerksInfoLightboxTemplate(options, data) {
        const {showMoreMembershipPriceRange} = this.options;
        options = Object.assign(options, {isFromResultsPopup: !Odigeo._.isUndefined(data)});
        const keys = await this.prepareKeys();

        const redesignedTemplate = this.templates.main({
            keys,
            pricesRange: showMoreMembershipPriceRange ? PRICE_RANGE : PRICE_RANGE.filter((item) => item !== 'five'),
            btnClass: options.isFromResultsPopup ? 'continue_with_member_lightbox' : 'want_be_member_lightbox',
            perks: this.getPerks(),
            steps: STEPS,
        });
        this.$el.html(redesignedTemplate);
    },
    async openMembershipPerksInfoLightbox(data) {
        await this.renderPerksInfoLightboxTemplate(this.options, data);
        Odigeo.UIElements.toggleWidgetsDialogs(this.name, true);
        this.$el.find(this.selectors.membershipPerksInfoLightboxContainer).addClass(openClass);
        this.$el.find(this.selectors.lightboxImageContainer).css('background-image', `url('${this.keys.lightboxImage}')`);
    },
    onMembershipPerksInfoLightboxButton(e) {
        const {isPaymentPage} = this.options;
        if (!isPaymentPage) {
            trackingUtils.trackEvent(UNLOCKED_ACTION, 'prime_mem_select_more_info');
        }
        this.onCloseMembershipPerksInfoLightbox(e);
    },
    onCloseMembershipPerksInfoLightboxTappingOutside(e) {
        if ($(e.target).hasClass('perks_info_lightbox_container')) {
            this.onCloseMembershipPerksInfoLightbox(e);
        }
    },
    trackingCloseMembershipPerksInfoLightbox() {
        const {isResultsPage, isPaymentPage} = this.options;
        if (isPaymentPage) {
            (Odigeo.Utils.isMobile()) ? revampTrackingLabel('closeKnowMoreFlightsPrimeLightbox') :
                trackingUtils.trackEventWithCategory('flights_ancillaries_page', UNLOCKED_ACTION, 'know_more_close_pay_sce');
        } else {
            const trackingCategory = isResultsPage ? 'flights_results' : 'flights_pax_page';
            trackingUtils.trackEventWithCategory(trackingCategory, UNLOCKED_ACTION, 'know_more_close');
        }
    },
    onCloseMembershipPerksInfoLightbox(e) {
        e.stopPropagation();
        this.closeMembershipPerksInfoLightbox();
        this.trackingCloseMembershipPerksInfoLightbox();
    },
    onClickTermsAndConditions(e) {
        trackingUtils.trackEvent(UNLOCKED_ACTION, `unlocked_terms_and_conditions_sce:${this.model.get('state')}`);
        trackFrontEventsUtils.trackClickEvent(e);
    },
    closeMembershipPerksInfoLightbox() {
        const $container = this.$el.find(this.selectors.membershipPerksInfoLightboxContainer);
        if ($container.hasClass(openClass)) {
            Odigeo.trigger(`${this.id}:openOrClosePerksMembershipDialog`, false);
            Odigeo.UIElements.toggleWidgetsDialogs(this.name, false);
            $container.removeClass(openClass);
        }
        if (Odigeo.Utils.isRequestApp('dp')) {
            Odigeo.Device.getViewport().removeClass('od-viewport-no-vertical-scroll');
        }
    },
    resetMembershipPerksInfoLightbox() {
        const $container = this.$el.find(this.selectors.membershipPerksInfoLightboxContainer);
        if ($container.hasClass(openClass)) {
            $container.remove();
        }
    },
    async prepareKeys() {
        const keys = this.getHeaderKeys();
        const lightboxKeys = this.obtainLightboxKeys();
        const tablesKeys = this.obtainTablesKeys();
        const lightboxStepKeys = this.obtainStepKeys();
        const genericKeys = this.obtainGenericKeys();
        Object.assign(keys, lightboxKeys, tablesKeys, genericKeys, lightboxStepKeys);

        await this.replaceKeyArguments(keys);
        return keys;
    },
    async replaceKeyArguments(keys) {
        const {membershipSubscriptionOfferDTO} = await this.model.getSubscriptionOffer();
        const membershipSubscriptionPrice = this.model.getSubscriptionPrice();
        let {renewalPrice, renewalDuration, durationTimeUnit} = membershipSubscriptionOfferDTO;
        const freeTrialDays = Odigeo.Utils.convertOfferToFreeTrialDuration(membershipSubscriptionOfferDTO);

        renewalPrice = Odigeo.Utils.formatCurrency(renewalPrice, Odigeo.Utils.Currency);
        const {durationUnit} =
            Odigeo.Utils.convertOfferToOfferDuration({
                renewalDuration,
                durationTimeUnit,
            },
            keys.renewalTime.year,
            keys.renewalTime.month,
            keys.renewalTime.months,
            );

        keys.membershipHeaderTxt = Odigeo.Utils.replaceCmsKeyArgsByName(keys.membershipHeaderTxt, {freeTrialDays});
        keys.membershipLightboxPerksDesc.one =
            Odigeo.Utils.replaceCmsKeyArgs(keys.membershipLightboxPerksDesc.one, membershipSubscriptionPrice);

        keys.membershipLightboxPerksDesc.five = Odigeo.Utils
            .replaceCmsKeyArgsByName(keys.membershipLightboxPerksDesc.five, {renewalTime: durationUnit, renewalPrice, freeTrialDays});
        keys.membershipLightboxPerksTitle.five = Odigeo.Utils
            .replaceCmsKeyArgsByName(keys.membershipLightboxPerksTitle.five, {freeTrialDays});
    },
    obtainLightboxKeys() {
        const lightboxTitleKeys = this.obtainLightboxTitleKeys();
        const lightboxDescKeys = this.obtainLightboxDescKeys();
        const lightboxDescExtraKeys = this.obtainLightboxDescExtraKeys();
        const lightboxPillKeys = this.obtainLightboxPillKeys();
        const lightboxPillOverTitleKeys = this.obtainLightboxPillOverTitleKeys();
        const lightboxRenewalTime = this.lightboxRenewalTime();
        return Odigeo._.merge(
            {},
            lightboxTitleKeys,
            lightboxDescKeys,
            lightboxPillKeys,
            lightboxDescExtraKeys,
            lightboxPillOverTitleKeys,
            lightboxRenewalTime);
    },

    lightboxRenewalTime() {
        return {
            renewalTime: {
                month: this.keys.membershipLightboxRenewalTimeMonth || '',
                months: this.keys.membershipLightboxRenewalTimeMonths || '',
                year: this.keys.membershipLightboxRenewalTimeYear || '',
            },
        };
    },

    obtainLightboxTitleKeys() {
        const membershipLightboxPerksTitle = {
            one: this.keys.membershipLightboxPerksOneTitle,
            two: this.keys.membershipLightboxPerksTwoTitle,
            three: Odigeo.Membership.isHotelsForPrime ?
                this.keys.membershipLightboxPerksThreeBTitle : this.keys.membershipLightboxPerksThreeTitle,
            four: this.keys.membershipLightboxPerksFourTitle,
            five: this.keys.membershipLightboxPerksFiveTitle,
        };
        return {membershipLightboxPerksTitle};
    },
    obtainLightboxDescKeys() {
        const membershipLightboxPerksDesc = {
            one: this.keys.membershipLightboxPerksOneDesc,
            two: this.keys.membershipLightboxPerksTwoDesc,
            three: Odigeo.Membership.isHotelsForPrime ?
                this.keys.membershipLightboxPerksThreeBDesc : this.keys.membershipLightboxPerksThreeDesc,
            four: this.keys.membershipLightboxPerksFourDesc,
            five: this.keys.membershipLightboxPerksFiveDesc,
        };
        return {membershipLightboxPerksDesc};
    },
    obtainLightboxDescExtraKeys() {
        return {
            membershipLightboxPerksDescExtra: {
                one: this.keys.membershipLightboxPerksOneDescExtra,
                two: this.keys.membershipLightboxPerksTwoDescExtra,
                three: this.keys.membershipLightboxPerksThreeDescExtra,
                four: this.keys.membershipLightboxPerksFourDescExtra,
                five: this.keys.membershipLightboxPerksFiveDescExtra,
            },
        };
    },
    obtainLightboxPillOverTitleKeys() {
        return {
            membershipLightboxPerksPillOverTitle: {},
        };
    },
    obtainLightboxPillKeys() {
        const membershipLightboxPerksPill = {
            one: this.keys.membershipLightboxPerksOnePill,
            two: this.keys.membershipLightboxPerksTwoPill,
            three: this.keys.membershipLightboxPerksThreePill,
            four: this.keys.membershipLightboxPerksFourPill,
            five: this.keys.membershipLightboxPerksFivePill,
        };
        return {membershipLightboxPerksPill};
    },
    obtainStepKeys() {
        const {isResultsPage} = this.options;
        return {
            membershipLightboxSteps: isResultsPage ? this.obtainResultsStepKeys() : this.obtainOthersStepKeys(),
        };
    },
    obtainResultsStepKeys() {
        return {
            one: this.keys.membershipLightboxResultsStepOneText,
            two: this.keys.membershipLightboxResultsStepTwoText,
            three: this.keys.membershipLightboxResultsStepThreeText,
        };
    },
    obtainOthersStepKeys() {
        return {
            one: this.keys.membershipLightboxOthersStepOneText,
            two: this.keys.membershipLightboxOthersStepTwoText,
            three: this.keys.membershipLightboxOthersStepThreeText,
        };
    },
    obtainTablesKeys() {
        const membershipLightboxTableTitle = this.keys.membershipLightboxTableTitle;
        const membershipLightboxTableImportRow = {
            one: this.keys.membershipLightboxTableImportRowOne,
            two: this.keys.membershipLightboxTableImportRowTwo,
            three: this.keys.membershipLightboxTableImportRowThree,
            four: this.keys.membershipLightboxTableImportRowFour,
            five: this.keys.membershipLightboxTableImportRowFive,
        };
        const membershipLightboxTableAverageRow = {
            one: this.keys.membershipLightboxTableAverageRowOne,
            two: this.keys.membershipLightboxTableAverageRowTwo,
            three: this.keys.membershipLightboxTableAverageRowThree,
            four: this.keys.membershipLightboxTableAverageRowFour,
            five: this.keys.membershipLightboxTableAverageRowFive,
        };
        return {membershipLightboxTableTitle, membershipLightboxTableImportRow, membershipLightboxTableAverageRow};
    },
    obtainGenericKeys() {
        const tableImport = this.keys.membershipLightboxTableImportHeader;
        const tableAverage = this.keys.membershipLightboxTableAverageHeader;
        const lightboxStepTitle = this.keys.membershipLightboxStepTitle;
        const lightboxLegalTerms = this.keys.membershipLightboxLegalTerms;
        const membershipLightboxLegalLink = this.keys.membershipLightboxLegalLink;
        const membershipLightboxLegalLinkText = this.keys.membershipLightboxLegalLinkText;
        const membershipLightboxButton = this.keys.membershipLightboxButton;
        return {tableImport, tableAverage, lightboxStepTitle, lightboxLegalTerms, membershipLightboxLegalLink,
            membershipLightboxLegalLinkText, membershipLightboxButton};
    },
    getHeaderKeys() {
        return {
            membershipLightboxLayerTitle: this.keys.membershipLightboxLayerTitle,
            membershipHeaderTitle: this.keys.membershipHeaderTitle,
            membershipHeaderTxt: this.keys.membershipHeaderTxt,
        };
    },
})));
